import { calc } from 'csx';
import { type Styles } from 'react-modal';
import { type CSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../../core/styles.constants';

export const modalStyle = (isMobile?: boolean): Styles => ({
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: '1px 2px 15px rgba(0, 0, 0, 0.25)',
    borderRadius: 8,
    width: 392,
    maxWidth: isMobile ? calc('100% - 30px') : undefined,
    backgroundColor: StyleConstants.WHITE_COLOR,
  },
});

export const modalBody: CSSProperties = {
  wordBreak: 'break-word',
  lineBreak: 'strict',
  textAlign: 'right',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  width: '100%',
};

export const modalTitle: CSSProperties = {
  maxWidth: 150,
  wordBreak: 'break-word',
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const columnHeader: CSSProperties = {
  wordBreak: 'break-word',
  textAlign: 'center',
  fontSize: StyleConstants.HEADER_FONT_SIZE,
  fontWeight: StyleConstants.HEADER_FONT_WEIGHT,
  fontFamily: StyleConstants.HEADER_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  paddingBottom: 12,
};

export const modalList: CSSProperties = {
  marginTop: 24,
  marginBottom: 24,
};

export const button: CSSProperties = {
  marginTop: 12,
};

export const bodyText: CSSProperties = {
  marginBottom: 8,
  wordBreak: 'break-word',
  textAlign: 'center',
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const deleteButton: CSSProperties = {
  cursor: 'pointer',
  wordBreak: 'break-word',
  marginTop: 12,
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.PINK_COLOR,
};

export const deleteIcon: CSSProperties = {
  height: 24,
  maxWidth: 24,
};

export const checkIcon = (isActive: boolean): CSSProperties => ({
  color: isActive ? StyleConstants.LIGHT_GREEN_COLOR : StyleConstants.LIGHT_GREY_COLOR,
});

export const uploadText: CSSProperties = {
  width: 125,
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const rowItem = (isLastItem = false): CSSProperties => ({
  marginBottom: isLastItem ? 0 : 12,
  width: '100%',
});

/** What is wrong with a field, right under it, in the colour the portal's other errors use. */
export const errorText: CSSProperties = {
  marginTop: -4,
  wordBreak: 'break-word',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.PINK_COLOR,
};
